import { ICollectionDetailsResponse } from "app/components/CollectionDetails/interfaces";
import { http } from "./http"

export const getCollection = (slug) => {
  return http.get<ICollectionDetailsResponse>(`collections/${slug}`);
}